import { FC } from "react";
import { Building } from "lucide-react";
import { CopropertyDto } from "api/coproperty";
import { EligibilityChip, EligibilityVerdict } from "./CopropertyFieldControls";

interface CopropertyIdentityCardProps {
  coproperty: CopropertyDto;
  /** Verdict de la sous-étape copropriété, affiché en pastille (absent tant qu'aucun enregistrement). */
  verdict?: EligibilityVerdict | null;
  /** Retour à la recherche pour rattacher une autre copropriété. */
  onChange?: () => void;
  isChangeDisabled?: boolean;
}

/**
 * Carte d'identité de la copropriété rattachée, colonne de gauche des sous-étapes MRI :
 * nom, adresse, immatriculation, verdict, et le lien « Changer » quand l'étape le permet.
 */
export const CopropertyIdentityCard: FC<CopropertyIdentityCardProps> = ({
  coproperty,
  verdict = null,
  onChange,
  isChangeDisabled = false,
}) => {
  const address = coproperty.address?.adresseFormattee || coproperty.address?.ligne1 || null;

  return (
    <div className="flex flex-col gap-3 rounded-xl border bg-white p-4">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-primary/10">
          <Building className="h-5 w-5 text-primary" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold text-zinc-800">{coproperty.name || address || "Copropriété"}</p>
          {address && <p className="truncate text-xs text-gray-500">{address}</p>}
          {coproperty.registrationNumber && (
            <p className="text-xs text-gray-500">Immatriculation {coproperty.registrationNumber}</p>
          )}
        </div>
      </div>
      {(verdict || onChange) && (
        <div className="flex items-center justify-between gap-2 border-t border-gray-100 pt-3">
          {verdict ? <EligibilityChip verdict={verdict} /> : <span />}
          {onChange && (
            <button
              type="button"
              disabled={isChangeDisabled}
              onClick={onChange}
              className="text-[13px] font-medium text-primary hover:underline disabled:opacity-50"
            >
              Changer
            </button>
          )}
        </div>
      )}
    </div>
  );
};
